// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
// } from "@mui/material";
// import axios from "axios";
// import userService from "../../../services/userService";

// export default function CMS() {
//   const [copies, setCopies] = useState([]);
//   const [filtered, setFiltered] = useState([]);
//   const [language, setLanguage] = useState("en");
//   const [search, setSearch] = useState("");

//   // 🔥 Fetch copies
//   const fetchCopies = async () => {
//     try {
//     //   const res = await axios.get("/api/admin/copies-full");
//       const res = await userService.getFullCopies();
//       console.log(res.data[0])
//       alert(res.data[0])
//       setCopies(res.data);
//       setFiltered(res.data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchCopies();
//   }, []);

//   // 🔍 Search filter
//   useEffect(() => {
//     const f = copies.filter(item =>
//       item._id.toLowerCase().includes(search.toLowerCase()) ||
//       item.default_text.toLowerCase().includes(search.toLowerCase())
//     );
//     setFiltered(f);
//   }, [search, copies]);

//   // ✏️ Handle change
//   const handleChange = (index, value) => {
//     const updated = [...filtered];
//     updated[index].translations[language] = value;
//     setFiltered(updated);
//   };

//   // 💾 Save changes
//   const saveChanges = async () => {
//     try {
//       await axios.post("/api/admin/update-copies", filtered);
//       alert("✅ Saved successfully");
//       fetchCopies();
//     } catch (err) {
//       console.error(err);
//       alert("❌ Save failed");
//     }
//   };

//   return (
//     <Box>
//       <Typography variant="h5" mb={2}>
//         🌍 CMS Translation Manager
//       </Typography>

//       {/* Controls */}
//       <Box display="flex" gap={2} mb={2}>
//         <TextField
//           label="Search"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />

//         <FormControl sx={{ minWidth: 120 }}>
//           <InputLabel>Language</InputLabel>
//           <Select
//             value={language}
//             label="Language"
//             onChange={(e) => setLanguage(e.target.value)}
//           >
//             <MenuItem value="en">English</MenuItem>
//             <MenuItem value="es">Spanish</MenuItem>
//             <MenuItem value="fr">French</MenuItem>
//           </Select>
//         </FormControl>

//         <Button variant="contained" onClick={saveChanges}>
//           💾 Save Changes
//         </Button>
//       </Box>

//       {/* Table */}
//       <Paper>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell><b>Key</b></TableCell>
//               <TableCell><b>Default (EN)</b></TableCell>
//               <TableCell><b>Translation</b></TableCell>
//               <TableCell><b>Screens</b></TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {filtered.map((item, index) => (
//               <TableRow key={item._id}>
//                 <TableCell>{item._id}</TableCell>

//                 <TableCell> {item.default_text}</TableCell>

//                 <TableCell>
//                   <TextField
//                     fullWidth
//                     value={item.translations?.[language] || ""}
//                     onChange={(e) =>
//                       handleChange(index, e.target.value)
//                     }
//                   />
//                 </TableCell>

//                 <TableCell>
//                   {item.screens?.join(", ")}
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </Paper>
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Tabs,
  Tab,
  Chip,
  Button,
  CircularProgress,
  Paper,
  Grid,
} from "@mui/material";
import userService from "../../../services/userService";

const API = "http://localhost:8000/api/admin";

export default function Copies() {
  const [copies, setCopies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);

  const [page, setPage] = useState(0);
const [pageSize] = useState(50); // fetch 50 at a time
const [hasMore, setHasMore] = useState(true);

const fetchCopies = async (page = 0) => {
  setLoading(true);
  try {
    const res = await userService.getFullCopies(page * pageSize, pageSize); // pass skip & limit
    const data = res.data;

    // Append new data instead of replacing
    setCopies(prev => [...prev, ...data]);
    setFiltered(prev => [...prev, ...data]);

    if (data.length < pageSize) setHasMore(false); // no more data
  } catch (err) {
    console.error(err);
  }
  setLoading(false);
};

//   // ✅ Fetch copies
//   const fetchCopies = async () => {
//     setLoading(true);
//     try {
//       const res = await userService.getFullCopies();
//       const data = res.data; // Axios already parses JSON
//       console.log(data)
//       setCopies(data);
//       setFiltered(data);
//     } catch (err) {
//       console.error(err);
//     }
//     setLoading(false);
//   };

  useEffect(() => {
    fetchCopies();
  }, []);

  // ✅ Search filter
  useEffect(() => {
    const result = copies.filter(item =>
      item.default_text.toLowerCase().includes(search.toLowerCase()) ||
      item._id.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(result);
  }, [search, copies]);

  // ✅ Update translation
  const updateTranslation = async (id, value) => {
    setSavingId(id);

    try {
      await fetch(`${API}/copies/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          lang: language,
          text: value,
        }),
      });
    } catch (err) {
      console.error(err);
    }

    setSavingId(null);
  };

  // ✅ Handle input change
  const handleChange = (item, value) => {
    setCopies(prev =>
      prev.map(c =>
        c._id === item._id
          ? {
              ...c,
              translations: {
                ...c.translations,
                [language]: value,
              },
            }
          : c
      )
    );
  };

  // ✅ Translate missing
  const translateMissing = async () => {
    setLoading(true);
    try {
      await fetch(`${API}/auto-translate`, {
        method: "POST",
      });
      fetchCopies();
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  // ✅ Status badge
  const getStatus = (item) => {
    const text = item.translations?.[language];
    if (!text || text === item.translations?.en) {
      return <Chip label="Missing" color="warning" size="small" />;
    }
    return <Chip label="Done" color="success" size="small" />;
  };

  const handleAIRewrite = async (id) => {
    setSavingId(id);
    try {
      const res = await fetch(`${API}/copies/ai-rewrite/${id}`, { method: "POST" });
      const updated = await res.json();
      setCopies(prev =>
        prev.map(c => c._id === id ? updated : c)
      );
    } catch (err) {
      console.error(err);
    }
    setSavingId(null);
  };

  return (
    <Box>
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h5">CMS Translations</Typography>

        <Button
          variant="contained"
          onClick={translateMissing}
        >
          Translate Missing
        </Button>
      </Box>

      {/* SEARCH */}
      <TextField
        fullWidth
        placeholder="Search copies..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2 }}
      />

      {/* LANGUAGE TABS */}
      <Tabs
        value={language}
        onChange={(e, val) => setLanguage(val)}
        sx={{ mb: 2 }}
      >
        <Tab label="English" value="en" />
        <Tab label="Spanish" value="es" />
        <Tab label="French" value="fr" />
      </Tabs>

      {/* LOADING */}
      {loading && page === 0 ? (
        <CircularProgress />
      ) : (
        <>
          <Grid container spacing={2}>
            {filtered.map((item) => (
              <Grid item xs={12} key={item._id}>
                <Paper sx={{ p: 2 }}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="caption" color="text.secondary">
                      {item._id}
                    </Typography>
                    {getStatus(item)}
                  </Box>

                  <Typography sx={{ mb: 1 }}>
                    {item.translations?.en}
                  </Typography>

                  <TextField
                    fullWidth
                    value={item.translations?.[language] || ""}
                    onChange={(e) => handleChange(item, e.target.value)}
                    onBlur={(e) =>
                      updateTranslation(item._id, e.target.value)
                    }
                    placeholder={`Translate to ${language}`}
                  />

<Button
  variant="outlined"
  onClick={() => handleAIRewrite(item._id)}
  disabled={savingId === item._id}
>
  {savingId === item._id ? "Rewriting..." : "AI Rewrite"}
</Button>

                  {savingId === item._id && (
                    <Typography variant="caption">
                      Saving...
                    </Typography>
                  )}
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* LOAD MORE BUTTON */}
          {hasMore && (
            <Box display="flex" justifyContent="center" mt={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  const nextPage = page + 1;
                  setPage(nextPage);
                  fetchCopies(nextPage);
                }}
                disabled={loading}
              >
                {loading ? "Loading..." : "Load More"}
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}